import React from 'react'

const ProductManagementRegionSubcategory: React.FC = () => (
  <svg width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.0769043" width="72" height="72" rx="14.5455" fill="url(#paint0_linear_4674_17908)" />
    <path
      d="M22.4756 30.0739C22.4756 30.2209 22.4756 30.3679 22.4756 30.4659C22.4756 35.7581 22.5246 41.0993 22.4756 46.3915C22.4756 48.2046 23.8966 49.5766 25.6607 49.5766C32.57 49.5276 39.4792 49.5766 46.3885 49.5766C48.2995 49.5766 49.5736 48.3026 49.5736 46.3915C49.5736 41.0993 49.5736 35.7581 49.5736 30.4659C49.5736 30.3189 49.5736 30.2209 49.5736 30.0739C40.4593 30.0739 31.4919 30.0739 22.4756 30.0739ZM41.9783 37.5712C41.9783 38.4042 41.2923 39.0412 40.5083 39.0412H31.4919C30.6589 39.0412 30.0219 38.3552 30.0219 37.5712C30.0219 36.7382 30.7079 36.1011 31.4919 36.1011H40.5083C41.2923 36.1011 41.9783 36.7872 41.9783 37.5712Z"
      fill="white"
    />
    <path
      d="M49.3286 28.5554H22.6716C21.7406 28.5554 20.9565 27.7714 20.9565 26.8403V24.2922C20.9565 23.3612 21.7406 22.5772 22.6716 22.5772H49.3286C50.2596 22.5772 51.0437 23.3612 51.0437 24.2922V26.8893C50.9947 27.7714 50.2596 28.5554 49.3286 28.5554Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17908"
        x1="35.5325"
        y1="0.0769068"
        x2="91.0286"
        y2="43.2769"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6600E8" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProductManagementRegionSubcategory
